// src/features/changelog/hooks/useChangelog.js
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeChangelog } from '../utils/changelog';

export function useChangelog() {
  const { t } = useTranslation(['common']);
  const [releases, setReleases] = useState([]);
  const [latest, setLatest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      try {
        const response = await fetch('/changelog.json', { signal: controller.signal });
        if (!response.ok) throw new Error(t('common:changelog.error_loading'));

        const normalized = normalizeChangelog(await response.json());
        setReleases(normalized.releases);
        setLatest(normalized.latest);
      } catch (err) {
        if (err.name === 'AbortError') return;
        setError(err.message);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    load();
    return () => controller.abort();
  }, [t]);

  return { releases, latest, loading, error };
}
